/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, ElementRef, inject, NgZone, OnInit, signal, ViewChild, ViewEncapsulation } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputOtp } from 'primeng/inputotp';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Avatar } from 'primeng/avatar';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';

import { ProgressSpinner } from 'primeng/progressspinner';
import { FirebaseAuthService } from '../../../services/firebase.auth.service';
import { User } from '@angular/fire/auth';
import { CartItem, DefaultMessages, folsomGeoJSON, IMessage, MessageType, OrderDetails, ranchoCordovaGeoJSON, UserProfile } from '../../../constants';
import { CartComponent } from '../../components/cart/cart.component';
import { PaymentsComponent } from '../../components/payments/payments.component';
import { OrderHistoryComponent } from '../../components/order-history/order-history.component';
import { FirebaseFunctionsService } from '../../../services/firebase.functions.service';
import { EditItemComponent } from '../../components/edit-item/edit-item.component';
import { FirebaseFirestoreService } from '../../../services/firebase.firestore.service';
import { injectStripe } from 'ngx-stripe';
import { debounceTime, forkJoin, Subscription } from 'rxjs';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { VoiceRecongnitionPermissionsComponent } from '../../components/voice-recongnition-permissions/voice-recongnition-permissions.component';
import { OrderDetailsComponent } from '../../components/order-details/order-details.component';
import { UtilityService } from '../../../services/utility.service';
import Fuse, { FuseResult } from 'fuse.js';
import { ImageModule } from 'primeng/image';
import { NumericInputModeDirective } from '../../../directives/numeric-input-mode.directive';
import * as turf from '@turf/turf';
import { Feature, Polygon } from 'geojson';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';

@Component({
    selector: 'app-customer-home',
    templateUrl: './customer-home.component.html',
    styleUrl: './customer-home.component.scss',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ButtonModule,
        InputTextModule,
        IftaLabelModule,
        InputGroupAddonModule,
        Avatar,
        InputOtp,
        ProgressSpinner,
        DynamicDialogModule,
        InfiniteScrollDirective,
        ImageModule,
        NumericInputModeDirective
    ],
    standalone: true,
    providers: [DialogService],
    encapsulation: ViewEncapsulation.None
})
export class CustomerHomeComponent implements OnInit {
  domSanitizer = inject(DomSanitizer);
  firebaseAuthService = inject(FirebaseAuthService);
  firebaseFunctionsService = inject(FirebaseFunctionsService);
  firebaseFirestoreService = inject(FirebaseFirestoreService);
  dialogService = inject(DialogService);
  utilityService = inject(UtilityService);
  stripe = injectStripe();
  ngZone = inject(NgZone);
  router = inject(Router);


  defaultMessages = DefaultMessages;
  messageType = MessageType;
  showMessageInputContainer = true;
  showLoginFlow = false;
  showLoginForm = false;
  otpSent = false;
  message = new FormControl('');
  otp = new FormControl('', [Validators.maxLength(4), Validators.minLength(4), Validators.pattern(`^[0-9]*$`)]);
  phoneNumber = new FormControl('', [Validators.maxLength(10), Validators.minLength(10), Validators.pattern(`^[0-9]*$`)]);

  @ViewChild('chatContent',{read: ElementRef}) chatContentRef: ElementRef | null = null;
  // @ViewChild('inputOtp', {read:  ElementRef}) inputOtp: ElementRef | null = null;
  @ViewChild(InputOtp) inputOtp?: InputOtp;
  @ViewChild('messageInput',{read: ElementRef}) messageInput: ElementRef | null = null;
  @ViewChild('suggestionscontainer',{read: ElementRef}) suggestionscontainer: ElementRef | null = null;

  user = signal<User|null>(null);
  userProfile = signal<UserProfile|null>(null);
  userDetermined = false;

  messages: IMessage[] = [];
  voiceMessage = '';
  devicePushTokenSaved = false;

  shouldShowDefaultPromptsOnLogin = true;
  chatHistoryLoadedCompletly = false;
  voiceRecognitionInProgress = false;
  voiceRecognitionPermissionsGiven = false;
  voiceRecognitionPermissionsStatus?: {
    speechRecognizerPermissionStatus: {status: string, canAskAgain: boolean, granted: boolean}, 
    microphonePermissionStatus: {status: string, canAskAgain: boolean, granted: boolean},
    notSupported: boolean
  };
  topGroceryData: {
    groceryCategoryList: {category: string; items: []}[]
    groceryCategories: [];
    groceryList: [];
  } | null = null;
  userGroceryHistoryData = [];
  showTopGroceryCategories = false;
  grocerySuggestions: FuseResult<{name: string; category: string; orderedOn: number, id?: string, loading: boolean}>[] = [];
  selectedTopGroceryCategory?: {category: string; items: []};
  readyToChat = false;
  constructor() {
    this.firebaseAuthService.user$.subscribe(async (user) => {
      console.log(user);
      this.user.set(user);
      this.subscribeToUserProfile();
      if(!user) {
        this.messages = [];
        this.userProfile.set(null);
        this.addToMessages({message: this.defaultMessages.noLoginWelcomeMessgae, reply: false});
        this.showLoginFlow = true;
        // this.showLoginForm = true;
        this.login();
        this.otpSent = false;
        this.showMessageInputContainer = false;
        this.phoneNumber.reset(null, { onlySelf: true});
        this.otp.reset(null, { onlySelf: true});
      } else {
        this.userProfile.update((value) => ({
          ...value,
          uid: user.uid,
          name: user.displayName,
          lastLoginAt: user.metadata.lastSignInTime,
          email: user.email,
          phoneNumber: user.phoneNumber,
          photoUrl: user.photoURL
        } as UserProfile))
        this.showLoginFlow = false;
        this.showMessageInputContainer = true;
        if(this.shouldShowDefaultPromptsOnLogin) {
          this.addToMessages({message: 'Welcome back! ' + (user.displayName || ''), reference: 'welcomeMessage', reply: false});
          // if(user.displayName && !(!this.userProfile()?.personalization?.skipped && !this.userProfile()?.personalization?.favoriteStores && !this.userProfile()?.personalization?.organicVarient)) {
            // this.loggedInSessionDefaultPrompts();
          if(!this.messages.filter(m => m.reference != 'welcomeMessage').length) {
            this.getChatHistory(true);
          }
        }
        this.topGroceryData = await this.firebaseFirestoreService.getTopGroceries();
        this.userGroceryHistoryData = await this.firebaseFirestoreService.getUserGroceryHistory(user.uid);
        this.subscribeToOnMessageInputChange();
      }
    })
    
    


    // Retrieve the "setup_intent_client_secret" query parameter appended to
    // your return_url by Stripe.js
    const clientSecret = new URLSearchParams(window.location.search).get(
      'setup_intent_client_secret'
    );
    if(clientSecret) {
      this.retrievePaymentSetupIntent(clientSecret);
    }
  }

  subscribeToUserProfile() {
    this.firebaseFirestoreService.subscribeToUserProfile().subscribe({
      next: (userProfile) => {
        if(userProfile) {
          this.userProfile.update((value) => ({
            ...value,
            ...userProfile
          } as UserProfile));
         
          if(!userProfile.name) {
            this.addToMessages({message: 'What name should I put down for you?' , reply: false, reference: 'username'});
          } else if(!this.inPersonalizationFlow && !userProfile?.personalization?.skipped && !userProfile?.personalization?.favoriteStores && !userProfile?.personalization?.organicVarient) {
            this.startPersonalizationFlow();
          } else if(!this.inPersonalizationFlow){
            this.loggedInSessionDefaultPrompts();
          }
        }
        this.userDetermined = true;
        // if(!this.devicePushTokenSaved) {
        //   (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "get-device-push-token", data: null}));
        // }
        
        (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "loaded", data: null}));
        
      },
      error: () => {
        (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "loaded", data: null}));
      }
    })
  }

  async ngOnInit() {
    this.setVoiceRecognitionEvents();

    (window as any).onDevicePushToken = (tokenData: any) => {
      const {devicePushToken, permissionStatus} = tokenData;
      console.log(devicePushToken, permissionStatus);
      if(devicePushToken?.data) {
        this.ngZone.run(async () => {
          this.utilityService.notificationsPermissionStatus = permissionStatus;
          this.firebaseFirestoreService.addDeviceFCMToken(this.userProfile()?.uid as string, devicePushToken);
          this.devicePushTokenSaved = true;
        });
      }
      this.ngZone.run(() => {
        this.firebaseFirestoreService.updateUserDocument({permissions: {
          ...this.userProfile()?.permissions || {}, notifications: permissionStatus
        }});
      })
    }

    (window as any).onPushNotificationClicked = (notificationData: any) => {
      this.ngZone.run(() => {
        // Navigate based on notification data
        if (notificationData?.screen === 'orderDetails') {
          // if(notificationData.body) {
            this.addToMessages({message: notificationData.body, reply: false, type: MessageType.action, actions: [{
                label: 'View Order Details',
                value: 'view_order_details',
                action: () => this.showOrderDetails({ orderDocumentRef: this.firebaseFirestoreService.getDocRefForPath(notificationData.orderDocumentRefPath) } as OrderDetails)
              }]
            });
          // } else {
            this.showOrderDetails({ orderDocumentRef: this.firebaseFirestoreService.getDocRefForPath(notificationData.orderDocumentRefPath) } as OrderDetails);
          // }
        }
      })
    }

    (window as any).onVoiceRecognitionPermissionsChange = (permissions: any) => {
      console.log('onVoiceRecognitionPermissionsChange', permissions)
      this.voiceRecognitionPermissionsStatus = permissions;
      this.ngZone.run(() => {
        if(this.voiceRecognitionPermissionsStatus?.notSupported) {
          this.voiceRecognitionPermissionsGiven = false;
        } else {
          this.voiceRecognitionPermissionsGiven = !!(this.voiceRecognitionPermissionsStatus?.speechRecognizerPermissionStatus.granted && this.voiceRecognitionPermissionsStatus?.microphonePermissionStatus.granted);
        }
      })
    }

    (window as any).onLocationUpdate = (data: {location: {coords: {latitude: number; longitude: number}, timestamp: number}, permissionResponse: any}) => {
      const { location, permissionResponse}: {location: {coords: {latitude: number; longitude: number}, timestamp: number}, permissionResponse: any} = data;
      this.ngZone.run(() => {
        console.log('User location', location);
        this.utilityService.locationPermissionStatus = permissionResponse;
        this.utilityService.location = {latitude: location.coords.latitude, longitude: location.coords.longitude, timestamp: location.timestamp};
        this.checkIfUserLocationIsInOurOperatingAreas(this.utilityService.location);
      })
    }

    (window as any).onLocationPermissionStatus = (permissions: typeof this.utilityService.locationPermissionStatus) => {
      this.ngZone.run(() => {
        this.utilityService.locationPermissionStatus = permissions;
        this.askForLocationPermission();
      })
    }

    (window as any).onCameraPermissionStatus = (permissions: any) => {
      this.ngZone.run(() => {
        this.utilityService.cameraPermissionStatus = permissions;
      })
    }

    (window as any).onNotificationsPermissionStatus = (permissions: any) => {
      this.ngZone.run(() => {
        this.utilityService.notificationsPermissionStatus = permissions;
        this.firebaseFirestoreService.updateUserDocument({permissions: {
          ...this.userProfile()?.permissions || {}, notifications: permissions
        }});
      })
    }

    (window as any).onDeviceInfo = (info: any) => {
      this.ngZone.run(() => {
        console.log('onDeviceInfo', info);
        this.utilityService.deviceInfo = info;
      })
    }

    setTimeout(() => {
      (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "get-voice-recognition-permission-status", data: null}));
      (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "get-camera-permission-status", data: null}));
      (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "get-device-info", data: null}));
      (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "get-notifications-permission-status", data: null}));
    }, 500);
  }

  getDevicePushToken() {
    (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "get-device-push-token", data: null}));
  }

  getlocationPermissionStatus() {
    if((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify({action: "get-location-permission-status", data: null}));
    } else {
      navigator.permissions.query({ name: 'geolocation' }).then(result => {
        this.utilityService.locationPermissionStatus = (result.state == 'granted' ? {granted: true, status: 'granted'} : {granted: false, status: result.state, canAskAgain: result.state !== 'denied'}) as any;
        this.askForLocationPermission();
      });
    }
  }

  askForLocationPermission() {
    if(this.utilityService.locationPermissionStatus?.granted) {
      this.getUserLocation();
      return;
    }
    if(!this.utilityService.locationPermissionStatus?.canAskAgain) {
      this.addToMessages({
        message: 'Allow AnyStore to access your location. We need your location to see if we are operating in your area and serve you better.', 
        type: this.messageType.action, 
        reference: 'operating-area',  
        actions:[ 
          { label: 'Open Settings', value: 'open_settings', action: () => {
            if(!this.utilityService.locationPermissionStatus?.granted) {
              (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "open-settings", data: null}));
            } else {
              this.getUserLocation();
            }
          }}
        ], 
        reply: false
      })
      return;
    }

    localStorage.removeItem('operatingAreaDisclaimerShowed');
    this.addToMessages({
      message: 'We need your location to see if we are operating in your area and serve you better. ', 
      type: this.messageType.action, 
      reference: 'operating-area',  
      actions:[ 
        { label: 'Continue', value: 'continue', action: () => {
          this.getUserLocation();
        }},
        // { text: 'No, Thanks', actionType: 'button', action: () => {
        //   this.addToMessages({
        //     message: 'No worries! You can still start building your grocery list — just type or say what you need, and we'll guide you from there.', 
        //     reply: false
        //   })
        // }}
      ], 
      reply: false
    })
  }

  getUserLocation() {
    if((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify({action: "get-location", data: null}));
    } else {
      navigator.geolocation.getCurrentPosition((location) => {
        console.log('User location', location);
        this.utilityService.locationPermissionStatus = {granted: true, status: 'granted'} as any;
        this.utilityService.location = { latitude: location.coords.latitude, longitude: location.coords.longitude, timestamp: location.timestamp};
        this.checkIfUserLocationIsInOurOperatingAreas(this.utilityService.location);
      }, () => {
        this.utilityService.locationPermissionStatus = {granted: false, status: 'denied'} as any;

      });
    }
  }

  checkIfUserLocationIsInOurOperatingAreas(location: {latitude: number; longitude: number}) {
    const userPoint = turf.point([location.longitude, location.latitude]);
    const folsomPolygonFeature = turf.feature(turf.geometry('Polygon', folsomGeoJSON.geometry.coordinates)) as Feature<Polygon>;
    const ranchoPolygonFeature = turf.feature(turf.geometry('Polygon', ranchoCordovaGeoJSON.geometry.coordinates)) as Feature<Polygon>;

    const isInFolsom = turf.booleanPointInPolygon(userPoint, folsomPolygonFeature);
    const isInRanchoCordova = turf.booleanPointInPolygon(userPoint, ranchoPolygonFeature);

    const disclaimerShowed = localStorage.getItem('operatingAreaDisclaimerShowed');
    if (isInFolsom && !disclaimerShowed) {
      console.log("User is in Folsom");
      this.utilityService.isUserInOperatingArea = true;
      if(disclaimerShowed !== 'true') {
          this.addToMessages({
            message: "Awesome news — we're up and running in Folsom city and can't wait to shop and deliver for you! We make your grocery shopping easy, affordable, transparent and stress-free 😊", 
            reply: false
        })
      }
    } else if (isInRanchoCordova && !disclaimerShowed) {
      console.log("User is in Rancho Cordova");
      this.utilityService.isUserInOperatingArea = true;
      if(disclaimerShowed !== 'true') {
        this.addToMessages({
          message: "Awesome news — we're up and running in Rancho Cordova city and can't wait to shop and deliver for you! We make your grocery shopping easy, affordable, transparent and stress-free 😊", 
          reply: false
        })
      }
    } else if(!disclaimerShowed) {
      console.log("User is not in a supported city");
      this.utilityService.isUserInOperatingArea = false;
      this.addToMessages({
        message: 'Sorry! We are not yet operating in your city. We would love to serve you. Please vote for your city so we prioritize it.', 
        type: this.messageType.action, 
        reference: 'operating-area',  
        actions:[ 
          { label: 'Yes, I would love to vote for my city', value: 'vote_for_city', action: () => {
            this.firebaseFirestoreService.addLocationRequest(this.user()?.uid as string, location, true );
            this.addToMessages({message: 'Appreciate your interest. We will plan to start operations in your area soon', reply: false});
          }},
          { label: 'No, Thanks', value: 'no_thanks', action: () => {
            this.firebaseFirestoreService.addLocationRequest(this.user()?.uid as string, location, false );
            this.addToMessages({message: "No worries. We are expanding and can't wait to start operations in your area and provide service to you soon.", reply: false});
          }}
        ], 
        reply: false
      })
    } else if(disclaimerShowed && !isInFolsom && !isInRanchoCordova) {
      this.addToMessages({message: 'Appreciate your interest. We are working hard to start operations in your area and provide services to you soon.', reference: 'info', reply: false});
    }
    localStorage.setItem('operatingAreaDisclaimerShowed', JSON.stringify(true));
  }

  onTopGroceryCategorySelection(topCategory:{category: string; items: []}) {
    this.selectedTopGroceryCategory = topCategory;
    this.messageInput?.nativeElement.focus();
  }

  suggestionItemBeingAdded?: Partial<CartItem>;
  async onTopGroceryItemSelection(item: Partial<CartItem>) {
    if(item.id) {
      this.suggestionItemBeingAdded = {...item};
      const { name, location = '', quantity = '', unit = '', store = '', images = [], notes = '', id = '' } = item
      await this.firebaseFirestoreService.addItemToCart('from recent orders', {name, location, quantity, store, images, unit, notes, id });
      this.addToMessages({message: `Added ${name} to list`, reply: false});
      this.suggestionItemBeingAdded = undefined;
      return;      
    }
    const messageInputValue = this.message.getRawValue() || '';
    const messageInputValueArray = messageInputValue?.split(' ');
    messageInputValueArray.splice(messageInputValueArray.length - 1, 1, item.name || '');
    this.message.setValue(messageInputValueArray.join(' ') + ', ');
    this.messageInput?.nativeElement.focus();
  }

  getFuseSuggestions(value: string) {
    const options = {
      includeScore: true,
      minMatchCharLength: 1,
      keys: ['name']
    }
    const fuse = new Fuse([...this.userGroceryHistoryData, ...this.topGroceryData?.groceryList as []], options);
    const lastWord = (value || '').split(' ').pop()?.trim();
    if(!lastWord) {
      this.showTopGroceryCategories = true;
      this.grocerySuggestions = [];
      return;
    }
    // this.showTopGroceryCategories = false;
    this.selectedTopGroceryCategory = undefined;
    this.grocerySuggestions = fuse.search(lastWord as string);
    this.suggestionscontainer?.nativeElement.scrollTo({
      left: 0,
      behavior: 'auto'
    });
  }

  subscribeToOnMessageInputChange() {
    this.message.valueChanges.pipe(debounceTime(500)).subscribe((value) => {
      if(value) {
        this.getFuseSuggestions(value);
      }
    });
  }

  onBlur() {
    setTimeout(() => {
      if(!this.selectedTopGroceryCategory && !this.showTopGroceryCategories && this.grocerySuggestions.length === 0) {
        this.resetSuggestions();
      }
    }, 100);
  }

  onFocus() {
    if(this.showTopGroceryCategories || this.selectedTopGroceryCategory || this.grocerySuggestions.length > 1) {
      return;
    }
    this.showTopGroceryCategories = true;
    this.selectedTopGroceryCategory = undefined;
    this.getFuseSuggestions(this.message.getRawValue() || '');
  }

  resetSuggestions() {
    this.showTopGroceryCategories = false;
    this.selectedTopGroceryCategory = undefined;
    this.grocerySuggestions = [];
  }

  login(retry = false) {
    this.shouldShowDefaultPromptsOnLogin = false;
    this.showLoginForm = true;
    this.otpSent = false;
    if(!retry) {
      // this.addToMessages({message: this.defaultMessages.loginOptionSelected, reply: true});
      this.addToMessages({message: this.defaultMessages.phoneLoginPrompt, reply: false});
    } else {
      this.phoneNumber.reset();
    }
    
    setTimeout(() => {
      this.firebaseAuthService.setRecaptchaVerifier('recaptcha-container');
    }, 500)
    
  }

  loginWithNativeFirebase() {
    if(!this.phoneNumber.valid) {
      return;
    }
    this.addToMessages({message: 'Phone Number: ' + this.phoneNumber.getRawValue() , reply: true});

    (window as any).onLoginConfirmationResult = (error: any) => {
      if(error) {
        this.ngZone.run(() => {
          console.log(error);
          this.addToMessages({message: 'Unable to login at this time. Sorry for inconvenience, please try again later or reach our support', reply: false});
          this.phoneNumber.reset();
        });
        return;
      }
      this.ngZone.run(() => {
        this.addToMessages({message: 'Please enter below One Time Passcode send to your phone number', reply: false});
        this.otpSent = true;
        this.onOTPValueChange();
      })
    }

    (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "login", data: {phoneNumber: '+1' + this.phoneNumber.getRawValue()}}));
  }

  async loginWithPhoneNumber() {
    this.readyToChat = false;
    if(this.utilityService.deviceInfo) {
      console.log('native login')
      this.loginWithNativeFirebase();
      return;
    }

    if(!this.phoneNumber.valid) {
      return;
    }
    this.addToMessages({message: 'Phone Number: ' + this.phoneNumber.getRawValue() , reply: true});
    try {
      await this.firebaseAuthService.loginWithPhoneNumber('+1' + this.phoneNumber.getRawValue());
      this.addToMessages({message: 'Please enter below One Time Passcode send to your phone number', reply: false});
      this.otpSent = true;
      this.onOTPValueChange();
    } catch (error) {
      console.log(error)
      this.addToMessages({message: 'Failed to sent OTP to your phone number. Please try again.' , reply: false});
    }
  }

  onOTPValueChangeSubscription?: Subscription;
  onOTPValueChange() {
    this.onOTPValueChangeSubscription?.unsubscribe();
    this.onOTPValueChangeSubscription = this.otp.valueChanges.subscribe((value) => {
      if(value?.length === 6) {
        this.addToMessages({message: 'OTP: '+ value , reply: true});
        this.addToMessages({message: 'Verifying' , reply: false, type: MessageType.loader});
        this.clearResendOtpCounterInterval();
        this.verifyOTP();
      }
    })
  }

  verifyOTPWithNativeFirebase() {
    (window as any).onOTPVerificationSuccess = (data: any) => {
      this.ngZone.run(async() => {
        console.log('onVerifyOTP', data)
        const { uid } = data;
        if(!uid) {
          this.onOTPVerificationFailed();
          return;
        }
        
        try {
          const userCredentials = await this.firebaseAuthService.signInWithToken(uid);
          const userProfile = await this.firebaseFirestoreService.getUserDocument(userCredentials?.user as User);
          this.showLoginFlow = false;
          this.showMessageInputContainer = true;
          this.addToMessages({message: 'Verification Success! You are logged in now' , reply: false});
          setTimeout(() => {
            if(this.user()?.displayName && !(!userProfile?.personalization?.skipped && !userProfile?.personalization?.favoriteStores && !userProfile?.personalization?.organicVarient)) {
              this.loggedInSessionDefaultPrompts();
            }
          }, 500);
        } catch (error) {
          console.log(error);
          this.onOTPVerificationFailed();
        }
      });
    }

    (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "verify-otp", data: {otp: this.otp.getRawValue() as string}}));
  }

  onOTPVerificationFailed() {
    this.otp.reset();
    this.startResendOtpCounter();
    // this.addToMessages({message: 'Verification failed. Check your OTP and retry again' , reply: false});
    this.addToMessages({
      message: 'Verification failed. Check your OTP and retry again', 
      type: this.messageType.action, 
      reference: 'resentOtp',  
      actions:[ 
        { label: 'Resend OTP', value: 'resend', action: () => this.resendOTP() },
        { label: 'Try Other Number', value: 'try_other_number', action: () => {this.clearResendOtpCounterInterval(); this.login(true)} }
      ], 
      reply: false
    });
  }

  async verifyOTP() {
    if(this.utilityService.deviceInfo) {
      this.verifyOTPWithNativeFirebase();
      return;
    }

    try {
      const userCredentials = await this.firebaseAuthService.verifyOTP(this.otp.getRawValue() as string);
      const userProfile = await this.firebaseFirestoreService.getUserDocument(userCredentials?.user as User);
      this.showLoginFlow = false;
      this.showMessageInputContainer = true;
      this.addToMessages({message: 'Verification Success! You are logged in now' , reply: false});
      setTimeout(() => {
        if(this.user()?.displayName && !(!userProfile?.personalization?.skipped && !userProfile?.personalization?.favoriteStores && !userProfile?.personalization?.organicVarient)) {
          this.loggedInSessionDefaultPrompts();
        }
      }, 500);
    } catch (error) {
      console.log(error);
      this.otp.reset();
      this.startResendOtpCounter();
      // this.addToMessages({message: 'Verification failed. Check your OTP and retry again' , reply: false});
      this.addToMessages({
        message: 'Verification failed. Check your OTP and retry again', 
        type: this.messageType.action, 
        reference: 'resentOtp',  
        actions:[ 
          { label: 'Resend OTP', value: 'resend', action: () => this.resendOTP() },
          { label: 'Try Other Number', value: 'try_other_number', action: () => {this.clearResendOtpCounterInterval(); this.login(true)} }
        ], 
        reply: false
      });
    }
  }

  inPersonalizationFlow = false;
  startPersonalizationFlow() {
    this.inPersonalizationFlow = true;
    this.addToMessages({
      message: `Shall we quickly personalize your experience — your go-to stores and grocery preferences. Just takes 15 seconds`,
      type: this.messageType.action,
      reference: 'personalization',
      actions:[
        { label: "Let's Go", value: 'start_personalization', action: () => this.askForPreferredStores() },
        { label: 'Skip', value: 'skip_personalization', action: () => {
          this.inPersonalizationFlow = false;
          this.firebaseFirestoreService.updateUserDocument({personalization: {
            ...this.userProfile()?.personalization,
            skipped: true
          } as any})
          // this.loggedInSessionDefaultPrompts();
        } }
      ],
      reply: false
    })
  }

  askForPreferredStores() {
    this.addToMessages({
      message: 'Which stores do you usually shop from?',
      type: this.messageType.action,
      reference: 'personalization-stores',
      actions:[
        { label: 'Skip', value: 'skip_stores', action: () => {
          this.askForGroceryPreference('No worries.');
        }}
      ],
      reply: false
    })
    this.messageInput?.nativeElement.focus();
  }

  askForGroceryPreference(preText: string) {
    this.addToMessages({
      message: `${preText} How do you prefer your grocery items to be?`,
      type: this.messageType.action,
      reference: 'personalization-grocery',
      actions:[
        { label: 'Only Organic', value: 'organic', action: () => {
            this.addToMessages({message: 'Only Organic', reply: true})
            this.addToMessages({message: 'Got it. We will keep your grocery preference in mind while shopping for you.', reply: false})
            this.updateUserPersonalization('Only Organic', 'personalization-grocery');
            this.inPersonalizationFlow = false;
            // this.loggedInSessionDefaultPrompts();
          }
        },
        { label: 'Organic when available', value: 'organic_when_available', action: () => {
            this.addToMessages({message: 'Organic when available', reply: true})
            this.addToMessages({message: 'Got it. We will keep your grocery preference in mind while shopping for you.', reply: false})
            this.updateUserPersonalization('Organic when available', 'personalization-grocery');
            this.inPersonalizationFlow = false;
            // this.loggedInSessionDefaultPrompts();
          }
        },
        { label: 'Non Organic', value: 'non_organic', action: () => {
            this.addToMessages({message: 'Non Organic', reply: true})
            this.addToMessages({message: 'Got it. We will keep your grocery preference in mind while shopping for you.', reply: false})
            this.updateUserPersonalization('Non Organic', 'personalization-grocery');
            this.inPersonalizationFlow = false;
            // this.loggedInSessionDefaultPrompts();
          }
        },
        { label: 'Smart Shopper Decision', value: 'shopper_decision', action: () => {
            this.addToMessages({message: 'Smart Shopper Decision', reply: true})
            this.addToMessages({message: 'Got it. We will keep your grocery preference in mind while shopping for you.', reply: false})
            this.updateUserPersonalization('Smart Shopper Decision', 'personalization-grocery');
            this.inPersonalizationFlow = false;
            // this.loggedInSessionDefaultPrompts();
          }
        },
        { label: 'Skip', value: 'skip_grocery_preference', action: () => {
            this.addToMessages({message: "That's ok. We can always set your preferences later.", reply: false})
            this.firebaseFirestoreService.updateUserDocument({personalization: {
              ...this.userProfile()?.personalization,
              skipped: true
            } as any})
            this.inPersonalizationFlow = false;
            // this.loggedInSessionDefaultPrompts();
          }
        }
      ],
      reply: false
    })
  }

  resendOtpCounter = signal(15);
  resendOtpCounterInterval?: ReturnType<typeof setInterval>;
  startResendOtpCounter() {
    this.resendOtpCounterInterval = setInterval(() => {
      this.resendOtpCounter.set(this.resendOtpCounter() - 1);
      if(this.resendOtpCounter() === 0) {
        this.clearResendOtpCounterInterval();
      }
    }, 1000)
  }

  clearResendOtpCounterInterval() {
    if(this.resendOtpCounterInterval) {
      clearInterval(this.resendOtpCounterInterval);
    }
  }

  async updateUserName(name: string, skip = false) {
    if(skip) {
      this.loggedInSessionDefaultPrompts();
      return;
    }

    // update user here
    try {
      this.addToMessages({message: 'Thank you ' + name, reply: false});
      await this.firebaseAuthService.updateUserProfile(this.user() as User, {displayName: name, photoURL: null});
      await this.firebaseFirestoreService.updateUserDocument({name});
      // this.loggedInSessionDefaultPrompts();
    } catch (error) {
      console.log(error);
    }
    
  }

  loggedInSessionDefaultPrompts(message?: string) {
    if(this.readyToChat) {
      return;
    }
    this.addToMessages({
      message: message || 'Here are some quick actions to get started', 
      type: this.messageType.action, 
      reference: 'welcomeMessage',
      actions:[ 
        { label: 'Add Items To Shopping List', value: 'add_item', action: () => this.addItemToCart() },
        { label: 'View Shopping List', value: 'view_shopping_list', action: () => this.openCartInDialog() },
        { label: 'Generate List From Previous Orders', value: 'generate_list', action: () => this.generateListFromPreviousOrders() },
        // { text: 'Place Order', actionType: 'button', action: () => this.openOrderHistoryInDialog() },
        { label: 'Order history', value: 'view_order_history', action: () => this.openOrderHistoryInDialog() },
        { label: 'Payment Methods', value: 'view_payment_methods', action: () => this.openPaymentsInDialog() },
        { label: 'Logout', value: 'logout', action: () => this.logout() },
      ] , 
      reply: false
    });
    this.readyToChat = true;

    this.getlocationPermissionStatus();
  }

  async generateListFromPreviousOrders() {
    const ordersCount = await this.firebaseFirestoreService.getOrdersCount();
    if(ordersCount <= 0) {
      this.addToMessages({message: `You haven't created any orders yet. create your customized grocery list once. We'll remember your preferences and shop like you would everytime `, reply: false});
      return;
    }
    const created = await this.firebaseFunctionsService.createGroceryListFromHistory(this.userProfile() as UserProfile);
    if(created) {
      this.addToMessages({
        message: `✅ Generated your list from your past orders`,
        reply: false,
        type: this.messageType.action, 
        reference: 'add-item',
      });
    } else {
      this.addToMessages({message: `Sorry for inconvenience. We are unable to create your list at this time. Please try again later or talk to me to add items quickly`, reply: false});
    }

  }

  async getChatHistory(shouldScrollToBottom?: boolean) {
    const response = await this.firebaseFirestoreService.getChatHistory();
    if(response && response?.length > 0) {
      this.messages.splice(0,0,...response.reverse());
    } else {
      this.chatHistoryLoadedCompletly = true;
    }

    if(shouldScrollToBottom) {
      setTimeout(() => {
        this.chatContentRef?.nativeElement?.scroll({
          top: this.chatContentRef.nativeElement.scrollHeight,
          behavior: 'auto'
        });
      });
    }
  }

  onScroll() {
    if(!this.chatHistoryLoadedCompletly) {
      this.getChatHistory(false);
    }
  }

  addItemToCart() {
    // this.addToMessages({message: 'Add item to shopping list', reply: true});
    this.addToMessages({message: 'Sure! Just send a text or click on microphone and talk. <br><b>Example: Organic Bananas, Whole Milk from Costco Folsom</b><br><b>Example: Add Peanut butter, whole wheat bread, A2 milk to shopping list</b>', reply: false});
    if(!this.user()) {
      this.addToMessages({message: 'Please login to add item to shopping list', reply: false});
      return;
    }
  }

  openCartInDialog() {
    // this.addToMessages({message: 'View shopping list', reply: true});
    if(!this.user()) {
      this.addToMessages({message: 'Please login to view your cart', reply: false});
      return;
    }

    const cartDialogRef = this.dialogService.open(CartComponent, {
      modal: true,
      closable: true,
      closeOnEscape: false,
      showHeader: false,
      contentStyle: {
        'height': '100%',
      },
      style: {
        'width': '100%',
        'max-width': '640px',
        'height': '100vh',
        'max-height': 'none',
        'border-radius': '0',
        'border': 'none'
      }
      
    });
    cartDialogRef.onClose.subscribe((data: OrderDetails | string) => {
      if( typeof data === 'string') {
        if(data === 'addItem') {
          this.addItemToCart();
        }
      } else if( typeof data === 'object') {
        this.addToMessages({
          message: 'Success! Your order has been placed. Enjoy your time where it matters to you. We will take care of your groceries.<b>We will charge your card on file only after shopping for you.</b><br/>Below are the order details',
          reply: false,
          type: MessageType.json,
          reference: 'orderDetails',
          orderDetails: data as OrderDetails
        });
      }
    });
  }

  openOrderHistoryInDialog() {
    // this.addToMessages({message: 'View order history', reply: true});
    const ordersDialogRef = this.dialogService.open(OrderHistoryComponent, {
      modal: true,
      closable: true,
      closeOnEscape: false,
      header: 'Your Orders',
      style: {
        'width': '100%',
        'max-width': '640px',
        'height': '100vh',
        'max-height': 'none',
        'border-radius': '0',
        'border': 'none'
      }
    });
    ordersDialogRef.onClose.subscribe(() => {});
  }

  openPaymentsInDialog() {
    // this.addToMessages({message: 'View payment methods', reply: true});
    const paymentsDialogRef = this.dialogService.open(PaymentsComponent, {
      modal: true,
      closable: true,
      closeOnEscape: false,
      header: 'Payment Methods',
      style: {
        'width': '100%',
        'max-width': '640px',
        'height': '100vh',
        'max-height': 'none',
        'border-radius': '0',
        'border': 'none'
      }
    });
    paymentsDialogRef.onClose.subscribe(({client_secret}) => {
      if(client_secret) {
        this.retrievePaymentSetupIntent(client_secret);
      }
    });
  }

  async openActiveOrderInDialog() {
    const lastOrder = await this.firebaseFirestoreService.getLastActiveOrder() as OrderDetails;
    if(lastOrder) {
      this.showOrderDetails(lastOrder);
    } else {
      this.addToMessages({message: 'No active order found', reply: false});
    }
  }

  async logout() {
    this.addToMessages({message: 'Log me out', reply: true});
    try {
      await this.firebaseAuthService.logout();
    } catch (error) {
      console.log(error)
      this.addToMessages({message: 'Failed to logout. Please try again.' , reply: false});
    }
  }
  
  async resendOTP() {
    this.clearResendOtpCounterInterval();
    await this.loginWithPhoneNumber();
  }

  sendMessage(text?: string) {
    this.resetSuggestions();
    const message = text || this.message.getRawValue();
    if(!message) { return }

    const previousPrompt = this.messages[this.messages.length-1];
    this.addToMessages({message: message , reply: true});
    this.addToMessages({message: '' , reply: false, type: MessageType.loader});

    if(previousPrompt.reference === 'username') {
      this.updateUserName(message, false);
    } else if(previousPrompt.reference?.includes('personalization')) {
      this.updateUserPersonalization(message, previousPrompt.reference);
    } else {
      this.formatMessage(message);
    }

    this.message.reset();
  }

  updateUserPersonalization(answer: string, reference: string ) {
    const personalization = {
      ...this.userProfile()?.personalization
    };
    if(reference.includes('store')) {
      personalization.favoriteStores = answer;
      setTimeout(() => {
        this.addToMessages({message: `Perfect!. <b>${answer}</b> added to your preferred stores. We will keep that in mind everytime we shop for you!`, reply: false})
        this.askForGroceryPreference('');
      })
    } else if(reference.includes('grocery')) {
      personalization.organicVarient = answer;
    }
    this.firebaseFirestoreService.updateUserDocument({personalization: personalization as any})
  }

  streamResponse = true;
  async formatMessage(promptText: string) {
    if(this.streamResponse) {
      this.getStreamResponseFromOpenAPI(promptText);
    } else {
      await this.getResponseFromOpenAPI(promptText);
    }
  }

  async getResponseFromOpenAPI(promptText: string) {
    const content = await this.firebaseFunctionsService.getProductsDataFromTextPrompt(promptText, this.user()?.uid as string);
    console.log(content);
    this.parserOpenAPIItemsResponse(content, promptText);
  }


  previewText?: SafeHtml;
  getStreamResponseFromOpenAPI(promptText: string) {
    const query = `?promptText=${encodeURIComponent(promptText)}&userId=${this.user()?.uid as string}`;
    const eventSource = new EventSource(`https://streamprompt-${environment.cloudFunctionProjectId}.a.run.app`+ query);

    // const previewContainer = document.getElementById('preview');
    // const finalResultContainer = document.getElementById('final-result');

    eventSource.addEventListener('preview', (event) => {
      console.log('preview', event.data)
      // remove trailing code block
       // replace '- ' with bullet
      const preview = JSON.parse(event.data);
      const formattedPreview = preview.replace(/```$/, '').replace(/^- /gm, '• ').replace(/\n/g, '<br/>');  
      console.log('formattedPreview', formattedPreview)
      this.previewText = this.domSanitizer.bypassSecurityTrustHtml(formattedPreview);
      this.chatContentRef?.nativeElement?.scroll({
        top: this.chatContentRef.nativeElement.scrollHeight,
        behavior: 'smooth'
      });
      // previewContainer.innerText = previewText;
    });

    eventSource.addEventListener('complete', (event) => {
      const finalJson = JSON.parse(event.data);
      console.log('finalJson', finalJson)
      eventSource.close();
      this.parseOpenAPIResponseForIntent(finalJson, promptText);
      this.previewText = '';
      // previewContainer.innerText = ''; // clear preview
      // finalResultContainer.innerText = JSON.stringify(finalJson, null, 2);
    });

    eventSource.addEventListener('error', (event) => {
      console.error('SSE error:', event);
      eventSource.close();
      this.previewText = '';
    });
  }

  parserOpenAPIItemsResponse(content: any, promptText: string) {
    const contentJson = (typeof content == 'string' ? JSON.parse(content || 'null') : content) as {
      parsedItems: [],
      relatedItems: [],
      basedOnPastOrders: []
    }
    console.log(contentJson);
    if(contentJson?.parsedItems.length) {
      const parsedItems = this.removeDefaultStoreName(contentJson.parsedItems);
      forkJoin(
        parsedItems.map((data: CartItem) => this.firebaseFirestoreService.addItemToCart(promptText, data))
      ).subscribe({
        next: (result) => {
          if(!result) {
            this.addToMessages({message: 'Failed to add item to shopping list. Please try again' , reply: false});
            return;
          }
          const savedItems = parsedItems.map((data: object, index: number) => ({...data, id: ((result as Array<string>)[index])})).filter((data: unknown, index: number) => (result as Array<unknown>)[index])
          this.addToMessages({
            message: `✅ Item/s added to your list. <br><br>
            You can edit an item to add details like:
            <ul class="force-disc">
              <li><em>Preferred brand or size</em></li>
              <li><em>Any ingredients to avoid</em></li>
              <li><em>Notes like "only if organic"</em></li>
            </ul><br>
            📸 A picture helps too — and the best part? <br>
            <b>You only need to do this once. We'll remember your preferences and shop like you would everytime</b>
            `,
            reply: false,
            type: this.messageType.action, 
            reference: 'add-item',
            // actions:[ 
            //   { text: 'View Shopping List', actionType: 'button', action: () => {
            //     this.openCartInDialog();
            //   }}
            // ],
          });
          // savedItems.forEach((data) => {
          //   this.addToMessages({message: '', cartItem: data as CartItem , reply: false, type: MessageType.json, reference: 'cartItem' });
          // });

          const suggestions = {
            relatedItems: this.removeDefaultStoreName(contentJson.relatedItems) || [],
            basedOnPastOrders: this.removeDefaultStoreName(contentJson.basedOnPastOrders) || [],
            actualMessage: promptText
          } 
          this.addToMessages({message: 'Quick Add Suggestions. Just click to add', suggestions: suggestions , reply: false, type: MessageType.json, reference: 'suggestions' });

        }, 
        error: () => this.addToMessages({message: 'Failed to add item to shopping list. Please try again' , reply: false})
      });
    } else {
      this.addToMessages({message: 'Your Grocery assistant understands only product related details. If you are looking for something else, please use below options to continue' , reply: false});
      this.loggedInSessionDefaultPrompts('Here are other actions you can perform');
    }
  }

  parseOpenAPIResponseForIntent(content: any, promptText: string) {
    switch(content.intent) {
      case 'add_items':
        this.parserOpenAPIItemsResponse(content, promptText);
        break;
      case 'view_cart':
        this.openCartInDialog();
        break;
      case 'auto_generate_shopping_list':
        this.generateListFromPreviousOrders();
        break;
      case 'checkout_order':
        this.openCartInDialog();
        break;
      case 'view_orders':
        this.openOrderHistoryInDialog();
        break;
      case 'track_order':
      case 'cancel_order':
        this.openActiveOrderInDialog();
        break;
      case 'view_shopping_list':
        this.openCartInDialog();
        break;
      case 'list_features':
        this.addToMessages({
          message: 'Here are quick actions you can perform', 
          type: this.messageType.action, 
          reference: 'welcomeMessage',
          actions:[ 
            { label: 'Add Items To Shopping List', value: 'add_item', action: () => this.addItemToCart() },
            { label: 'View Shopping List', value: 'view_shopping_list', action: () => this.openCartInDialog() },
            { label: 'Generate List From Previous Orders', value: 'generate_list', action: () => this.generateListFromPreviousOrders() },
            // { text: 'Place Order', actionType: 'button', action: () => this.openOrderHistoryInDialog() },
            { label: 'Order history', value: 'view_order_history', action: () => this.openOrderHistoryInDialog() },
            { label: 'Payment Methods', value: 'view_payment_methods', action: () => this.openPaymentsInDialog() },
            { label: 'Logout', value: 'logout', action: () => this.logout() },
          ] , 
          reply: false
        });
        break;
      case 'why_anystore':
        this.whyAnystore();
        break;
      case 'unknown':
        this.addToMessages({message: 'Sorry, I only understand AnyStore related queries. If you are looking for something else, please use below options to continue' , reply: false});
        this.addToMessages({
          message: 'Here are other actions you can perform', 
          type: this.messageType.action, 
          reference: 'welcomeMessage',
          actions:[ 
            { label: 'Add Items To Shopping List', value: 'add_item', action: () => this.addItemToCart() },
            { label: 'View Shopping List', value: 'view_shopping_list', action: () => this.openCartInDialog() },
            { label: 'Generate List From Previous Orders', value: 'generate_list', action: () => this.generateListFromPreviousOrders() },
            // { text: 'Place Order', actionType: 'button', action: () => this.openOrderHistoryInDialog() },
            { label: 'Order history', value: 'view_order_history', action: () => this.openOrderHistoryInDialog() },
            { label: 'Payment Methods', value: 'view_payment_methods', action: () => this.openPaymentsInDialog() },
            { label: 'Logout', value: 'logout', action: () => this.logout() },
          ] , 
          reply: false
        });
        break;
      default:
        this.addToMessages({message: 'Sorry, I only understand AnyStore related queries. If you are looking for something else, please use below options to continue' , reply: false});
        this.addToMessages({
          message: 'Here are other actions you can perform', 
          type: this.messageType.action, 
          reference: 'welcomeMessage',
          actions:[ 
            { label: 'Add Items To Shopping List', value: 'add_item', action: () => this.addItemToCart() },
            { label: 'View Shopping List', value: 'view_shopping_list', action: () => this.openCartInDialog() },
            { label: 'Generate List From Previous Orders', value: 'generate_list', action: () => this.generateListFromPreviousOrders() },
            // { text: 'Place Order', actionType: 'button', action: () => this.openOrderHistoryInDialog() },
            { label: 'Order history', value: 'view_order_history', action: () => this.openOrderHistoryInDialog() },
            { label: 'Payment Methods', value: 'view_payment_methods', action: () => this.openPaymentsInDialog() },
            { label: 'Logout', value: 'logout', action: () => this.logout() },
          ] , 
          reply: false
        });
        break;
    }
    this.removeLoaderMessage();
  }

  whyAnystore() {
    this.addToMessages({message: '', type: this.messageType.info, reference: 'whyAnystore', reply: false});
  }

  removeDefaultStoreName(items: []) {
    return items.map((item: CartItem) => {
        return {
          ...item,
          store: item.store?.toLowerCase() === 'anystore' || item.store?.toLowerCase() === 'any store' ? '' : item.store
        }
      }).filter(item => !!item.name);
  }

  async addSuggestedItemToCart(message: string, item: CartItem) {
    this.firebaseFirestoreService.addItemToCart('Suggested for: ' + message, item);
  }

  editItem(item?: CartItem) {
    console.log(item);
    if(!item) return;
    const editItemDialogRef = this.dialogService.open(EditItemComponent, {
      modal: true,
      closable: true,
      closeOnEscape: false,
      header: 'Edit Item',
      style: {
        'width': '100%',
        'max-width': '640px',
        'height': '100vh',
        'max-height': 'none',
        'border-radius': '0',
        'border': 'none'
      },
      data: item
    });
    editItemDialogRef.onClose.subscribe((item) => {
      if(!item) return;
      this.addToMessages({message: 'Here is the updated item details.', cartItem: item as CartItem , reply: false, type: MessageType.json, reference: 'cartItem' });
    });
  }

  showOrderDetails(order?: OrderDetails) {
    if(!order) return;
    // this.addToMessages({message: 'View order history', reply: true});
    const ordersDialogRef = this.dialogService.open(OrderDetailsComponent, {
      modal: true,
      closable: true,
      closeOnEscape: false,
      showHeader: false,
      contentStyle: {
        'height': '100%',
      },
      style: {
        'width': '100%',
        'max-width': '640px',
        'height': '100vh',
        'max-height': 'none',
        'border-radius': '0',
        'border': 'none'
      },
      data: {order, userRole: 'customer'}
    });
    ordersDialogRef.onClose.subscribe(() => {});
  }

  removeLoaderMessage() {
    const previousPrompt = this.messages[this.messages.length-1];
    if(previousPrompt?.type === MessageType.loader) {
      this.messages.pop();
    }
  }

  async addToMessages({
    message,
    reply,
    type = MessageType.message,
    actions,
    reference,
    cartItem,
    orderDetails,
    suggestions,
    sentBy
  }: Omit<IMessage, 'timestamp'>) {
    // remove loader prompt
    this.removeLoaderMessage();

    const newMessage = {
      reply,
      message,
      type,
      actions: actions || null,
      reference: reference || null,
      cartItem: cartItem || null,
      suggestions: suggestions || null,
      orderDetails: orderDetails || null,
      sentBy: sentBy || (reply ? this.user()?.uid : 'agent') || 'non-loggedin-user',
      timestamp: new Date().valueOf()
    } as IMessage

    // add new prompt
    this.messages = [
      ...this.messages, 
      newMessage
    ];

    if(newMessage.type !== MessageType.loader && newMessage.reference !== 'welcomeMessage' && newMessage.reference !== 'info' ) {
      await this.firebaseFirestoreService.addToChatHistory(newMessage);
    }

    setTimeout(() => {
      this.chatContentRef?.nativeElement?.scroll({
        top: this.chatContentRef.nativeElement.scrollHeight,
        behavior: 'smooth'
      });
    }, 500);
  } 

  retrievePaymentSetupIntent(clientSecret: string) {
    // Retrieve the SetupIntent
    this.stripe.retrieveSetupIntent(clientSecret).subscribe(({setupIntent}) => {
      // Inspect the SetupIntent `status` to indicate the status of the payment
      // to your customer.
      //
      // Some payment methods will [immediately succeed or fail][0] upon
      // confirmation, while others will first enter a `processing` state.
      //
      // [0]: https://stripe.com/docs/payments/payment-methods#payment-notification
      switch (setupIntent?.status) {
        case 'succeeded': {
          this.addToMessages({message: 'Success! Your payment method has been saved.' , reply: false});
          
          break;
        }

        case 'processing': {
          this.addToMessages({message: 'Processing payment details. We will update you when processing is complete.' , reply: false});
          break;
        }

        case 'requires_payment_method': {
          this.addToMessages({message: 'Failed to process payment details. Please try another payment method.' , reply: false});
          // Redirect your user back to your payment page to attempt collecting
          // payment again

          break;
        }
      }
    });
  }

  setVoiceRecognitionEvents() {
    (window as any).onVoiceRecognitionStarted = () => {
      console.log('onVoiceRecognitionStarted');
      this.ngZone.run(() => {
        this.voiceRecognitionInProgress = true;
        this.voiceRecognitionPermissionsGiven = true;
      })
    };

    (window as any).onVoiceRecognitionStopped = () => {
      console.log('onVoiceRecognitionStopped');
      this.ngZone.run(() => {
        // this.voiceRecognitionInProgress = false;
      })
    };

    // fired when partial results are available
    (window as any).onVoiceRecognitionPartialResults = (partialText: any) => {
      console.log('onVoiceRecognitionPartialResults');
      console.log(partialText);
      this.ngZone.run(() => {
        this.voiceMessage = partialText;
      })
    };

    // fired with final results when voice recognition is stopped
    (window as any).onVoiceRecognitionResults = (text: any) => {
      console.log('onVoiceRecognitionResults');
      console.log(text);
      this.ngZone.run(() => {
        this.voiceMessage = text;
      })
    };

    (window as any).onVoiceRecognitionError = (data: any) => {
      console.log('onVoiceRecognitionError');
      console.log(data);
      this.ngZone.run(() => {
        // this.voiceRecognitionInProgress = false;
        // TODO: add logic to show error message
      })
    };
  }

  sendVoiceMessage() {
    this.voiceRecognitionInProgress = false;
    const value = this.message.getRawValue()?.trim();
    if(!value) {
      this.sendMessage(this.voiceMessage);
    } else if(value) {
      this.message.setValue(value + ', ' + this.voiceMessage + ' ');
      this.messageInput?.nativeElement.focus();
    }
    this.voiceMessage = '';
  }

  startVoiceRecording() {
    this.resetSuggestions();
    console.log(this.voiceRecognitionPermissionsStatus, this.voiceRecognitionPermissionsGiven);
    if(!this.voiceRecognitionPermissionsGiven) {
      this.showVoiceRecordingPermissionRequestModal();
      return;
    }
    this.voiceMessage = '';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "start-voice-recognition", data: null}));
  }

  stopVoiceRecording() {
    this.voiceRecognitionInProgress = false;
    this.voiceMessage = '';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "stop-voice-recognition", data: null}));
  }

  stopAndSendMessage() {
    this.sendVoiceMessage();
    // this.voiceRecognitionInProgress = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "stop-voice-recognition", data: null}));
  }

  showVoiceRecordingPermissionRequestModal() {
    const voiceRecognistionPermissionsDialogRef = this.dialogService.open(VoiceRecongnitionPermissionsComponent, {
      modal: true,
      closable: !this.voiceRecognitionPermissionsStatus?.microphonePermissionStatus.canAskAgain || !this.voiceRecognitionPermissionsStatus.speechRecognizerPermissionStatus.canAskAgain,
      closeOnEscape: false,
      showHeader: true,
      header: 'Speech Recognition Permissions',
      contentStyle: {
        'height': '100%',
      },
      style: {
        'width': '100%',
        'max-width': '640px',
        'height': '100vh',
        'max-height': 'none',
        'border-radius': '0',
        'border': 'none'
      },
      data: this.voiceRecognitionPermissionsStatus
    });
    voiceRecognistionPermissionsDialogRef.onClose.subscribe((agreed: boolean) => {
      if(agreed) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "start-voice-recognition", data: null}));
      }
    });
  }

  explore() {
    (window as any).open('https://www.anystore.app', '_blank');
  }

  viewAvailableBatches() {
    this.router.navigate(['/available-batches']);
  }
}
